import PT, { oneOfType } from 'prop-types';
import IPT from 'react-immutable-proptypes';
import { Link } from 'react-router-dom';
import s from './styles.scss';
import cx from 'classnames';

const GroupedQuestionsTabNav = ({
  classId,
  examId,
  rootQuestionDescendants,
  buildQuestionSetUrl,
}) => {
  if (rootQuestionDescendants.size < 2) {
    return null;
  }
  return (
    <div className={s.groupedQuestionsTabNav}>
      <div className={s.container}>
        {rootQuestionDescendants.map((question) => (
          <Link
            key={question.get('id')}
            to={buildQuestionSetUrl(examId, question.get('id'), classId)}
            activeClassName={cx(s.tab, s.selected)}
            className={s.tab}
          >
            {question.get('full_serial')}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default GroupedQuestionsTabNav;

GroupedQuestionsTabNav.propTypes = {
  classId: oneOfType([PT.string, PT.number]),
  examId: oneOfType([PT.string, PT.number]),
  rootQuestionDescendants: IPT.seq,
  buildQuestionSetUrl: PT.func.isRequired,
};
